<template>

  <div class="pc-page">
    <div class="test_main test_main_2">
      <Nav></Nav>
      <div class="test_step clearfix">
        <router-link to="/learningAbility/learningPotential/guide/1" class="button">Part A</router-link>
      </div>
      <div class="test_test clearfix">
        <div class="test_test_l">
          <div class="titbox center">
            <h4 class="cn_tit">信息加工能力</h4>
            <h6 class="en_tit">Information Processing</h6>
          </div>
          <div class="desc">
            <p>信息加工能力是指人对信息的处理能力，主要包括对信息的理解能力、分析能力、评价能力和综合能力。</p>
          </div>
          <div class="notice">
            提示：点击“Part A”进入测试！
          </div>
        </div>
        <div class="test_test_r">
          <img src="~@/assets/01.png" alt="" class="img"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    import Nav from '../../../../components/learningAbility/learningPotential.vue';
    export default {
    data() {
      return {}
    },
    components: { Nav },
    mounted() {
      $('.test_menu .item').eq(0).addClass('item_2');
    },
    updated() {

    },
  }
</script>

<style>
  .evalu-nav {
    background: #333;
    opacity: 1;
  }
</style>
